import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=af89a05a&scoped=true"
import script from "./Conclusion.vue?vue&type=script&lang=ts"
export * from "./Conclusion.vue?vue&type=script&lang=ts"
import style0 from "./Conclusion.vue?vue&type=style&index=0&id=af89a05a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af89a05a",
  null
  
)

export default component.exports